export default {
  setLoading(state, payload) {
    state.loading = payload
  },
  setTemplate(state, payload) {
    state.template = payload
  },
  setTemplates(state, payload) {
    state.templates = payload
  },
  setPagination(state, payload) {
    state.pagination = { ...payload }
  },
  setMessageResource(state, payload) {
    state.messageResource = { ...payload }
  },
}
